/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetExploresQueryVariables = Types.Exact<{
  sortField: Types.InputMaybe<Types.ExploreSortField>;
  sortDirection: Types.InputMaybe<Types.SortDirection>;
  saved: Types.InputMaybe<Types.HexFilter>;
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  before: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  last: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type GetExploresQuery = {
  readonly __typename: "Query";
  readonly exploresV2: {
    readonly __typename: "SafeOrUnknownExploresConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "SafeOrUnknownExploresEdge";
      readonly node:
        | {
            readonly __typename: "Explore";
            readonly id: c.ExploreId;
            readonly createdDate: c.DateTimeString;
            readonly saved: boolean;
            readonly exploreCell: {
              readonly __typename: "ExploreCell";
              readonly id: c.ExploreCellId;
              readonly dataframe: c.ExploreCellDataframe | null;
            } | null;
            readonly hexVersion: {
              readonly __typename: "HexVersion";
              readonly id: c.HexVersionId;
              readonly title: string;
              readonly hexId: c.HexId;
            };
            readonly sourceHexVersion: {
              readonly __typename: "HexVersion";
              readonly id: c.HexVersionId;
              readonly hex: {
                readonly __typename: "Hex";
                readonly id: c.HexId;
                readonly title: string;
                readonly hexType: Types.HexType;
                readonly latestAskAgentChatThread: {
                  readonly __typename: "AgentChatThread";
                  readonly id: c.AgentChatThreadId;
                } | null;
              };
            } | null;
          }
        | {
            readonly __typename: "UnknownExplore";
            readonly id: c.ExploreId;
            readonly name: string;
            readonly createdDate: c.DateTimeString;
            readonly hexId: c.HexId;
          };
    }>;
  };
};

export const GetExploresDocument = /*#__PURE__*/ gql`
  query GetExplores(
    $sortField: ExploreSortField
    $sortDirection: SortDirection
    $saved: HexFilter
    $after: Cursor
    $before: Cursor
    $last: Int
    $first: Int
  ) {
    exploresV2(
      sortField: $sortField
      sortDirection: $sortDirection
      saved: $saved
      after: $after
      before: $before
      last: $last
      first: $first
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          ... on Explore {
            id
            createdDate
            saved
            exploreCell {
              id
              dataframe
            }
            hexVersion {
              id
              title
              hexId
            }
            sourceHexVersion {
              id
              hex {
                id
                title
                hexType
                latestAskAgentChatThread {
                  id
                }
              }
            }
          }
          ... on UnknownExplore {
            id
            name
            createdDate
            hexId
          }
        }
      }
    }
  }
`;

/**
 * __useGetExploresQuery__
 *
 * To run a query within a React component, call `useGetExploresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExploresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExploresQuery({
 *   variables: {
 *      sortField: // value for 'sortField'
 *      sortDirection: // value for 'sortDirection'
 *      saved: // value for 'saved'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetExploresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetExploresQuery,
    GetExploresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExploresQuery, GetExploresQueryVariables>(
    GetExploresDocument,
    options,
  );
}
export function useGetExploresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExploresQuery,
    GetExploresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExploresQuery, GetExploresQueryVariables>(
    GetExploresDocument,
    options,
  );
}
export function useGetExploresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetExploresQuery,
    GetExploresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetExploresQuery, GetExploresQueryVariables>(
    GetExploresDocument,
    options,
  );
}
export type GetExploresQueryHookResult = ReturnType<typeof useGetExploresQuery>;
export type GetExploresLazyQueryHookResult = ReturnType<
  typeof useGetExploresLazyQuery
>;
export type GetExploresSuspenseQueryHookResult = ReturnType<
  typeof useGetExploresSuspenseQuery
>;
export type GetExploresQueryResult = Apollo.QueryResult<
  GetExploresQuery,
  GetExploresQueryVariables
>;
